import { useMemo, ReactNode, forwardRef, ComponentProps } from 'react'
import classNames from 'classnames'
import { Override } from 'maeng-type/Common'

export type DropdownProps = Override<
  ComponentProps<'details'>,
  {
    open?: boolean
    label: ReactNode
    align?: 'start' | 'end'
    position?: 'top' | 'bottom' | 'left' | 'right'
    hover?: boolean
    children: ReactNode
  }
>

export const Dropdown = forwardRef<HTMLDetailsElement, DropdownProps>(
  (
    {
      open = false,
      label,
      children,
      align = 'start',
      position = 'bottom',
      hover = false,
      className: classProps = '',
      ...props
    },
    ref,
  ) => {
    const className = useMemo(() => {
      const aligns = {
        'dropdown-end': align === 'end',
      }
      const positions = {
        'dropdown-top': position === 'top',
        'dropdown-bottom': position === 'bottom',
        'dropdown-left': position === 'left',
        'dropdown-right': position === 'right',
      }

      return classNames({
        dropdown: true,
        'mb-32': true,
        'dropdown-hover': hover,
        'dropdown-open': open,
        ...aligns,
        ...positions,
        [classProps]: true,
      })
    }, [align, classProps, hover, open, position])

    return (
      <details ref={ref} className={className} {...props}>
        <summary className="btn m-1">{label}</summary>
        <div className="dropdown-content z-[1]">{children}</div>
      </details>
    )
  },
)

export default Dropdown
